module.exports = __webpack_public_path__ + "img/5d5947f.jpg";